<script lang="jsx">
import { mapState } from 'vuex'
import { appStoreMixin, deviceMixin } from '@/mixins'

export default {
  mixins: [appStoreMixin, deviceMixin],
  props: {
    mode: {
      type: String,
      default: 'inline'
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedKeys: [],
      openKeys: [],
      cacheOpenKeys: []
    }
  },
  computed: {
    ...mapState('permission', ['topMenu']),
    isSide () {
      return (
        this.layoutMode === 'side' ||
        (this.layoutMode === 'top' && this.isMobile)
      )
    }
  },
  watch: {
    collapsed (val) {
      if (val) {
        this.cacheOpenKeys = [].concat(this.openKeys)
        this.openKeys = []
      } else {
        this.openKeys = this.cacheOpenKeys
      }
    },
    $route (val) {
      this.updateMenu()
    }
  },
  methods: {
    onOpenChange (openKeys) {
      const latestKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.selectedKeys.indexOf(latestKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestKey ? [latestKey] : []
      }
    },
    handleMenuClick ({ item, key, keyPath }) {
      const menu = this.topMenu.filter(item => item.name === key)[0].menu

      this.$store.commit('permission/SET_MENUS', menu, {
        root: true
      })
      const isBoard = sessionStorage.getItem('isBoard')
      const snIsBoard = sessionStorage.getItem('snIsBoard')
      if (isBoard && (key === '医师服务' || key === '医事服务')) {
        this.$store.commit('app/SET_ROUTEURL', './website/#/data/home')
      } else if (+snIsBoard && key === '日志系统') {
        this.$store.commit('app/SET_ROUTEURL', './website/#/log-statistics/realtime-data')
      } else {
        this.$store.commit('app/SET_ROUTEURL', null)
      }
      this.selectedKeys = [keyPath[0]]
      sessionStorage.setItem('selectedKeys', JSON.stringify(this.selectedKeys))
    },
    updateMenu () {
      // fullPath : '/customs/export/query'
      // let openKeys = []
      // const { fullPath } = this.$route
      // const keyPath = fullPath.split('/')
      // keyPath.shift()
      // keyPath.pop()
      // this.selectedKeys = [fullPath]

      // if (this.mode === 'inline') {
      //   openKeys = generateOpenKeys(keyPath)
      // }

      // this.collapsed
      //   ? (this.cacheOpenKeys = openKeys)
      //   : (this.openKeys = openKeys)
      // console.log(fullPath, this.selectedKeys, this.openKeys)
    }
  },
  created () {
    // this.updateMenu()
    // this.selectedKeys = [this.topMenu[0].name]
    this.selectedKeys = JSON.parse(sessionStorage.getItem('selectedKeys')) || []
  },
  render () {
    const {
      isSide,
      menuTheme,
      mode,
      openKeys,
      selectedKeys,
      $route,
      topMenu,
      handleMenuClick,
      onOpenChange
    } = this

    const menuWrapClass = [
      'lu-menu',
      isSide && 'lu-menu__side',
      `lu-menu__${ menuTheme }`
    ]
    const menuProps = {
      mode,
      openKeys,
      selectedKeys,
      theme: menuTheme,
      defaultSelectedKeys: [$route.path]
    }

    const menuEvent = {
      click: handleMenuClick,
      openChange: onOpenChange
    }

    // 递归生成菜单
    function generateMenu (topMenu) {
      if (topMenu.length > 1) {
        return topMenu.map(menu => {
          // 不设置icon
          return (
            <a-menu-item key={ menu.name }>
              <span>{ menu.name }</span>
            </a-menu-item>
          )
        })
      }
    }

    return (
      <div class={ menuWrapClass }>
        <a-menu props={ menuProps } on={ menuEvent }>
          { generateMenu(topMenu) }
        </a-menu>
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
.lu-menu {
  &.lu-menu__side {
    // border-top: 1px solid #3d4348;

    &.lu-menu__light {
      border-top-color: rgba(61, 67, 72, 0.1);
    }
  }
}

.ant-menu {
  background: transparent;

  &.ant-menu-horizontal {
    height: 65px;
    display: flex;
    align-items: center;
  }

  .ant-menu-inline.ant-menu-sub {
    background: rgba(37, 37, 37, 1);
    box-shadow: none;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    padding: 0 40px;
  }

  .ant-menu-item {
    position: relative;
    border: none !important;
    font-size: 16px;
  }
  // .ant-menu-submenu-title,  .ant-menu-submenu-open, .ant-menu-submenu-selected, .ant-menu-submenu-active, .ant-menu-item-active{
  // }
  // .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-submenu-active, .ant-menu-submenu-title:hover{
  //    color: #486DFF !important;
  // }
  // .ant-menu-submenu-active .ant-menu-submenu-title:hover , .ant-menu-submenu:hover{
  //   color: #486DFF !important;
  // }
  .ant-menu-item-selected {
    background-color: #fff !important;
    font-weight: 600;
  }

  .ant-menu-item-active::after,
  .ant-menu-item-selected::after {
    content: "";
    width: 20px;
    height: 2px;
    background: #1890ff;
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
